import { useState, useEffect } from 'react';
import { Form, Input, Row, Col, Alert, Select } from 'antd';
import { InvoiceHeader as BaseInvoiceHeader } from '../../common/components';
import PageSpinner from '../../../../components/Spinner/PageSpinner';
import { syncSerieNCF, getSerieNCFBySeriesCode } from '../../../../services/serieNCFService';
import { formatDate } from '../../../../utils/dateUtils';
import { isEmpty } from '../../../../utils/common';

const InvoiceHeader = (props) => {
    const [serieNCF, setSerieNCF] = useState(null);
    const [loading, setLoading] = useState(true);
    const form = Form.useFormInstance();

    const cajaActiva = props?.cajaActiva;

    const rawLastNoUsed = serieNCF?.Last_No_Used;
    const parsedLastNoUsed = Number(rawLastNoUsed);

    const nextNum =
        rawLastNoUsed != null && !Number.isNaN(parsedLastNoUsed)
            ? String(parsedLastNoUsed + 1).padStart(8, '0')
            : 'XXXXXXXX';

    const establecimiento = isEmpty(serieNCF?.Establecimiento) ? 'XX' : serieNCF?.Establecimiento;
    const punto_emision = isEmpty(serieNCF?.Punto_de_Emision) ? 'XX' : serieNCF?.Punto_de_Emision;

    const fullComprobante = serieNCF
        ? `${establecimiento}-${punto_emision}-${nextNum}`
        : '-';

    useEffect(() => {
        const loadAllData = async () => {
            if (!cajaActiva) {
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                await syncSerieNCF();

                const serieCode = props?.documentType === "Invoice"
                    ? cajaActiva?.Numerador_facturas_NFC
                    : cajaActiva?.Numerador_abonos_NFC;

                if (serieCode) {
                    const serieNCFData = await getSerieNCFBySeriesCode(serieCode);
                    setSerieNCF(serieNCFData);
                }

            } catch (error) {
                console.error("Error in fetch sequence:", error);
            } finally {
                setLoading(false);
            }
        };

        loadAllData();
    }, [cajaActiva, props?.documentType]);

    useEffect(() => {
        if (!form.getFieldValue("Fiscal_Invoice_Type")) {
            form.setFieldValue("Fiscal_Invoice_Type", "Factura consumidor final");
        }
    }, [form]);

    return (
        <>
            <BaseInvoiceHeader {...props} />
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Fiscal_Invoice_Type"
                        label="Tipo de factura fiscal"
                        rules={[{ required: true, message: "Seleccione el tipo de factura fiscal" }]}
                    >
                        <Select
                            options={[
                                { value: "Factura consumidor final", label: "Factura consumidor final" },
                                { value: "Factura crédito fiscal", label: "Factura crédito fiscal" },
                            ]}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {loading ?
                <PageSpinner /> :
                <>
                    {!cajaActiva && (
                        <Alert
                            message="Caja Inactiva"
                            description="Se necesita una caja activa para cargar los datos de facturación y NCF."
                            type="error"
                            showIcon
                            style={{ marginBottom: 24 }}
                        />
                    )}

                    <Row gutter={16}>
                        <Col xs={24} sm={6}>
                            <Form.Item label="Factura Id" validateStatus={!cajaActiva ? "error" : ""}>
                                <Input disabled={true} value={serieNCF?.Last_No_Used || "-"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={6}>
                            <Form.Item label="C.A.I" validateStatus={!cajaActiva ? "error" : ""}>
                                <Input disabled={true} value={serieNCF?.No_Autorizacion_CAI || "-"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Comprobante" validateStatus={!cajaActiva ? "error" : ""}>
                                <Input disabled={true} value={fullComprobante || "-"} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Fecha autorización" validateStatus={!cajaActiva ? "error" : ""}>
                                <Input disabled={true} value={formatDate(serieNCF?.Fecha_Autorizacion) || "-"} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                            <Form.Item label="Fecha caducidad" validateStatus={!cajaActiva ? "error" : ""}>
                                <Input disabled={true} value={formatDate(serieNCF?.Fecha_Caducidad) || "-"} />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            }
        </>
    );
};

export default InvoiceHeader;
